import React from 'react';

export const Check = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 15" width="12px">
        <path
            fill="#353535"
            fillRule="evenodd"
            d="M6.272 13.728L.558 8.014A1.905 1.905 0 113.252 5.32l4.367 4.394 9.13-9.156a1.904 1.904 0 112.693 2.694L8.966 13.728a1.905 1.905 0 01-2.694 0z"
        />
    </svg>
);
